var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AnimationTypesConstants } from "../constants/animationTypesConstants";
import { AnimationManager } from "./AnimationManager";
import { WalkingCitizen } from "./WalkingCitizen";
var WalkingCitizensAnimator = /** @class */ (function (_super) {
    __extends(WalkingCitizensAnimator, _super);
    function WalkingCitizensAnimator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.animationRepeatInterval = 1000;
        _this.animationDuration = 15000;
        _this.maxStartingDelay = 4000;
        _this.spawnChancePercentage = 5;
        _this.animationType = AnimationTypesConstants.WalkingCitizens;
        _this.generateAnimation = function () { return new WalkingCitizen(); };
        return _this;
    }
    return WalkingCitizensAnimator;
}(AnimationManager));
export { WalkingCitizensAnimator };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/WalkingCitizensAnimator.ts
// module id = 2197
// module chunks = 3